module Meevo.Plugins.BusinessInfo {
    "use strict";
    /**
    * ImageGallery Section of BusinessInfo 
    */

    export class ImageGallerySection extends Meevo.Components.CommonClasses.CommonSectionBase {

        private imageGalleryService: Meevo.Components.Common.IImageGalleryService;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            imageGalleryService: Meevo.Components.Common.IImageGalleryService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService,sectionSecurityKey)

            this.imageGalleryService = imageGalleryService;
        }

        addImage() {
            return this.dataService.getTemplate('Tenant/BusinessInfo/ImageGallery')
                .then(result => {
                    result.fileType = Model.FileTypes.CustomDataImage;
                    result.file = result.meevoFile;
                    result.fileGuid = result.fileGuid;
                    result.mimeType = result.contentType;
                    result.isStorageUpdated = result.isStorageUpdated;
                    return result;
                })

        }

        getDefaultCriteria() {
            return { imageGalleryCategoryEnum: Model.ImageGalleryCategoryEnum.Business, IncludeInactive: true, IncludeActive: true }
        }


    }
}
